import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, computed, signal } from '@angular/core';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import {
    getImageTrackerStatusTypeFromAssetWarning,
    IMAGE_TRACKER_ASSET_WARNINGS_TRANSLATIONS,
    IMAGE_TRACKER_STATUS_TYPE_TRANSLATIONS,
    ImageTrackerAssetWarning,
    ImageTrackerStatusType,
} from 'visuals/interfaces/visuals-image-tracker.interface';
import { ICellRendererParams } from '@ag-grid-community/core';
import { TextWithTranslatableParams } from 'shared/interfaces/multipart-translatable-text.interface';
import { MultipartTranslatePipe } from 'shared/pipes/multipart-translate.pipe';

@Component({
    selector: 'app-image-tracker-asset-status-renderer',
    imports: [CommonModule, TooltipDirective, MultipartTranslatePipe, AsyncPipe],
    templateUrl: './image-tracker-asset-status-renderer.component.html',
    styleUrl: './image-tracker-asset-status-renderer.component.scss',
})
export class ImageTrackerAssetStatusRendererComponent implements ICellRendererAngularComp {
    protected readonly ImageTrackerStatusType = ImageTrackerStatusType;

    readonly assetWarning = signal<ImageTrackerAssetWarning>(ImageTrackerAssetWarning.GENERIC_WARNING);
    readonly assetExportDate = signal<Date | null | undefined>(undefined);

    readonly imageTrackerWarningType = computed<ImageTrackerStatusType>(() => {
        return getImageTrackerStatusTypeFromAssetWarning(this.assetWarning());
    });

    readonly tooltipText = computed<TextWithTranslatableParams[]>(() => {
        if (!this.assetWarning()) {
            if (this.assetExportDate()) {
                return [{ key: 'listing.visuals.imageTracker.asset.successfullyExported' }];
            } else {
                return [{ key: 'listing.visuals.imageTracker.asset.readyForExport' }];
            }
        }

        return [
            {
                key: IMAGE_TRACKER_STATUS_TYPE_TRANSLATIONS[this.imageTrackerWarningType()],
            },
            {
                key: IMAGE_TRACKER_ASSET_WARNINGS_TRANSLATIONS[this.assetWarning()],
            },
        ];
    });

    agInit(params: ICellRendererParams): void {
        this.assetWarning.set(params.data.warning);
        this.assetExportDate.set(params.data.exportedDate);
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }
}
